import './bootstrapWebpack'; // Important that this come first, to bootstrap webpack settings
/* eslint-disable-next-line owa-custom-rules/forbid-empty-import-statements-from-modules -- (https://aka.ms/OWALintWiki)
 * This is expected as this is a polyfill needs run as a side effect */
import 'owa-polyfills';
import patchMobX from 'owa-configure-mobx/lib/patchMobX';
import { configureMobX } from 'owa-configure-mobx/lib/configureMobX';
import { patchPerformance } from './patchPerformance';

import { patchNode } from './patchNode';
// Configure MobX; this needs to happen ahead of other imports since Satchel stores are created as
// a side effect of importing
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * This is expected as this is a polyfill needs run as a side effect*/
configureMobX();

// Monkey-patch MobX to proxy stale objects to the store
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * This is expected as this is a polyfill needs run as a side effect */
patchMobX();

// Monkey-patch DOM node APIs to avoid some component errors
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * This is expected as this is a polyfill needs run as a side effect */
patchNode();

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * This is expected as this is a polyfill needs run as a side effect */
patchPerformance();
